<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />

      <div class="selections">
        <el-button
          type="primary"
          @click="showDialog"
        >添加中控</el-button>
        <button-link
          type="success"
          to="/box_binding/warningLogs"
        >
          <slot>中控日志</slot>
        </button-link>
      </div>
    </div>
    <el-dialog
      title="添加中控"
      :visible.sync="dialogFormVisible"
      width="25%"
    >
      <el-form :model="form">
        <el-form-item
          label="中控编码"
          required
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.box_no"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="厂商"
          required
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="form.manufacturer"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="批次"
          required
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.batch" />
        </el-form-item>
        <el-form-item
          label="蓝牙MAC"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.bluetooth_mac" />
        </el-form-item>
        <el-form-item
          label="蓝牙TOKEN"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.bluetooth_token" />
        </el-form-item>
        <el-form-item
          label="中控型号"
          required
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.device_xing" />
        </el-form-item>
        <el-form-item
          label="imei号"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.imei_no" />
        </el-form-item>
        <!--                <el-form-item label="sim号" :label-width="formLabelWidth">-->
        <!--                    <el-input v-model="form.sim_no"/>-->
        <!--                </el-form-item>-->
        <el-form-item
          label="imsi号"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.imsi_no" />
        </el-form-item>
        <el-form-item
          label="iccid号"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.iccid_no" />
        </el-form-item>
        <el-form-item
          label="中控型号"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.mold" />
        </el-form-item>
        <el-form-item
          label="商户"
          required
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="form.merchant_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in merchantList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addBox"
        >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="解绑中控"
      :visible.sync="dialogConfirmVisible"
      width="25%"
    >
      <h2 style="color:red;">确认解绑中控吗？</h2>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogConfirmVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="unBind()"
        >确 定</el-button>
      </div>
    </el-dialog>

    <el-table
      :data="users"
      resource="box"
      :default-sort="{prop: 'id', order: 'descending'}"
    >
      <!-- <el-table-column
                 prop="id"
                 label="ID"
                 align="center"
                 sortable
                 show-overflow-tooltip
                 min-width="5%"
             />-->
      <el-table-column
        prop="box_no"
        label="中控号"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="bike_no"
        label="车辆编码"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />

      <el-table-column
        label="是否绑定"
        align="center"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_binding"
            type="success"
          >已绑定</el-tag>
          <el-tag
            v-else
            type="danger"
          >未绑定</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="batch"
        align="center"
        label="批次"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="imei_no"
        align="center"
        label="imei号"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="mold"
        align="center"
        label="中控型号"
        show-overflow-tooltip
        min-width="100"
      />
      <el-table-column
        prop="imsi_no"
        align="center"
        label="imsi号"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="iccid_no"
        align="center"
        label="iccid号"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="created_at"
        align="center"
        label="添加时间"
        show-overflow-tooltip
        min-width="120"
      />
      <!--            <el-table-column-->
      <!--                prop="updated_at"-->
      <!--                align="center"-->
      <!--                label="修改时间"-->
      <!--                show-overflow-tooltip-->
      <!--                min-width="10%"-->
      <!--            />-->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="120"
      >
        <template #default="{ row }">
          <input-edit
            :id="row.id"
            field="remark"
            :update="updateBoxRemark"
            v-model="row.remark"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="150"
        fixed="right"
      >
        <template #default="{ row}">
          <el-button
            type="success"
            @click="showDialogConfirmVisible(row)"
          >一键解绑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getBoxs, storeBox, unbindBox, updateBoxRemark } from "@/api/box";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import { mixinsAutoPageSize } from "@/libs/utils";
import InputEdit from "@c/quick-edit/InputEdit";
import ButtonLink from "@c/ButtonLink";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
import { setTimeout } from "timers";
export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    InputEdit,
    ButtonLink
  },
  data() {
    return {
      search: [
        {
          field: "box_no",
          label: "中控号"
        },
        {
          field: "remark",
          label: "备注"
        },
        {
          type: "el-select",
          field: "is_binding",
          label: "是否绑定",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: 1,
              label: "已绑定"
            },
            {
              value: 0,
              label: "未绑定"
            }
          ]
        }
      ],
      merchantList: [
        {
          id: "",
          name: "全部"
        }
      ], //商户列表
      options: [
        {
          value: "0",
          label: "未知"
        },
        {
          value: "1",
          label: "泰比特"
        },
        {
          value: "2",
          label: "威科姆"
        },
          {
              value: "3",
              label: "小安（电动车）"
          },{
              value: "4",
              label: "易强"
          },
          {
              value: "5",
              label: "格米利"
          }
      ],
      users: [],
      page: null,
      rowConfirm: "",
      dialogFormVisible: false,
      dialogConfirmVisible: false,
      formLabelWidth: "120px",
      form: {
        box_no: "",
        batch: "",
        device_xing: "",
        manufacturer: "1",
        bluetooth_mac: "",
        bluetooth_token: "",
        imei_no: "",
        iccid_no: "",
        sim_no: "",
        imsi_no: "",
        mold: "",
        merchant_id: 0
      },
      first_blood: true
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(54, newVal);
        const {
          data: { data, meta }
        } = await getBoxs(newVal.query);
        this.users = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);

      merchant.data.map(item => {
        this.merchantList.push({
          id: item.id,
          name: item.name
        });
      });
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });

        this.search[3].options.push.apply(
          this.search[3].options,
          merchant.data
        );
      }
    }
  },
  methods: {
    updateBoxRemark,
    showDialog() {
      this.dialogFormVisible = true;
    },
    async addBox() {
      await storeBox(this.form).then(res => {
        res.then(data => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.reload();
        });
      });
    },
    showDialogConfirmVisible(row) {
      if (row.is_binding == 0) {
        return;
      }
      this.dialogConfirmVisible = true;
      this.rowConfirm = row;
    },
    async unBind() {
      if (this.rowConfirm.is_binding == 0) {
        return;
      }
      await unbindBox(this.rowConfirm.id).then(res => {
        res.then(data => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.reload();
        });
      });
    }
  }
};
</script>
<style lang="scss" scope>
.header-button {
  display: flex;
  justify-content: space-between;

  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
